import { render, staticRenderFns } from "./BoxesByPartnerItem.vue?vue&type=template&id=1e705e57&scoped=true&"
import script from "./BoxesByPartnerItem.vue?vue&type=script&lang=js&"
export * from "./BoxesByPartnerItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxesByPartnerItem.vue?vue&type=style&index=0&id=1e705e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e705e57",
  null
  
)

export default component.exports